<template lang="pug">
div
  .steps(v-if="!_step")
    span.step(:class="activeStepClass(1)") 1
      span.label Allgemein
    span.step(:class="activeStepClass(2)") 2
      span.label Platzauswahl
    span.step(:class="activeStepClass(3) + ' ' + activeStepClass(4)") 3
      span.label Getränke
    span.step(:class="activeStepClass(5)" v-if="!onlyShowTicket") 4
      span.label Menüs
    span.step(:class="onlyShowTicket ? activeStepClass(5) : activeStepClass(6)") 5
      span.label Abschluss
  .multistep-tab(:class="activeTabClass(1)"): step1(:html="html" :phone="phone" :standalone="_step == 5" :order="order" :settings="settings" v-model:buttonDisabled="buttonDisabled" v-model:product="product" v-model:count="count")
  .multistep-tab(:class="activeTabClass(2)"): step(:product="product" :count="count" v-model:buttonDisabled="buttonDisabled2" :step="step")
  .multistep-tab(:class="activeTabClass(3)"): step2(:html="html" :order="order" :settings="settings" :product="product")
  .multistep-tab(:class="onlyShowTicket ? 'is--hidden' : activeTabClass(4)"): step3(:html="html" :order="order" :settings="settings" :product="product")
  .multistep-tab(:class="onlyShowTicket ? 'is--hidden' : activeTabClass(5)"): step4(:html="html" :standalone="_step == 4" v-if="_step != 5" :order="order" :settings="settings" :product="product" :count="count" v-model:buttonDisabled="buttonDisabled")
  .multistep-tab(:class="onlyShowTicket ? activeTabClass(4) : activeTabClass(6)"): step5(:html="html" :standalone="_step == (onlyShowTicket ? 4 : 6)" v-if="_step != 4" :order="order" :settings="settings" :product="product" :count="count")

  .navigation(v-if="!_step")
    button#prev-btn.btn.is--inverted.is--secondary(type='button' @click="prevStep" v-if="step != 1")
      span Zurück
    button#next-btn.btn.is--inverted(type='button' @click="nextStep" v-if="step != (onlyShowTicket ? 4 : 6)" :class="(buttonDisabled || buttonDisabled2) ? 'is--disabled' : ''")
      span Weiter

</template>

<script>
  // WICHTIG: _step wird nicht mehr funktonieren, da step anzahl nicht mehr stimmt.
import Step1 from '../TicketShop/Steps/Step1.vue'
import Step2 from '../TicketShop/Steps/Step2.vue'
import Step3 from '../TicketShop/Steps/Step3.vue'
import Step4 from '../TicketShop/Steps/Step4.vue'
import Step5 from '../TicketShop/Steps/Step5.vue'

import Step from './Step.vue'

export default {
  components: {Step1, Step2, Step3, Step4, Step5, Step},
  props: [
    "settings",
    "order",
    "html",
    "phone",
    "_step"
  ],
  data () {
    return {
      count: 1,
      product: null,
      step: 1,
      buttonDisabled: false,
      buttonDisabled2: false
    }
  },
  mounted () {
    if (this._step) this.step = this._step
    setTimeout(window.buildTooltip, 500)
  },
  watch: {
  },
  computed: {
    onlyShowTicket() {
      return this.product && this.product.only_show_ticket
    }
  },
  methods: {
    prevStep(){
      if (this.buttonDisabled) return false
      this.buttonDisabled2 = false
      document.getElementById('ticketShopWithMap').scrollIntoView(); //TODO id anpassen
      this.step--
      setTimeout(window.buildTooltip, 500)
    },
    nextStep(){
      if (this.buttonDisabled) return false
      document.getElementById('ticketShopWithMap').scrollIntoView(); //TODO id anpassen
      this.step++
      setTimeout(window.buildTooltip, 500)
    },
    activeTabClass(i){
      if(i != this.step) return "is--hidden"
    },
    activeStepClass(i){
      if(i === this.step) return "is--active"
      if(i < this.step) return "is--finished"
    }
  }
}
</script>
